module.exports = __webpack_public_path__ + "09_mustache_grey.fa47c05e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer3/09_mustache_grey.png
// module id = 64Qq
// module chunks = 0